"use strict";

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "Body", {
  enumerable: true,
  get: function get() {
    return _body["default"];
  }
});
Object.defineProperty(exports, "Heading", {
  enumerable: true,
  get: function get() {
    return _heading["default"];
  }
});
Object.defineProperty(exports, "Legal", {
  enumerable: true,
  get: function get() {
    return _legal["default"];
  }
});
Object.defineProperty(exports, "Text", {
  enumerable: true,
  get: function get() {
    return _text["default"];
  }
});
Object.defineProperty(exports, "Title", {
  enumerable: true,
  get: function get() {
    return _title["default"];
  }
});
exports["default"] = void 0;

var _body = _interopRequireDefault(require("./body"));

var _heading = _interopRequireDefault(require("./heading"));

var _legal = _interopRequireDefault(require("./legal"));

var _text = _interopRequireDefault(require("./text"));

var _title = _interopRequireDefault(require("./title"));

var _type = _interopRequireDefault(require("./type"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

// Deprecated, typed as any
// Deprecated, typed as any
var _default = _type["default"];
exports["default"] = _default;